import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import React, { useEffect } from "react";
import FAQForm from "./form/faq.form";
import { endpoint } from "@services/api.services";
import { format } from "date-fns";
import { useListData } from "@utils/query/index.query";
import { QueryData } from "@utils/interface/index.interface";
import { MomentsData } from "@utils/interface/journey.interface";
import { useSearchParams } from "react-router";
import { useMetaStore } from "@utils/states/index.state";
import { ColumnList } from "./column";
type Props = {};

const index: React.FC<Props> = ({}) => {
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<MomentsData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["faqs"],
    key: `${pathname}-listing`,
  });
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  const columns = ColumnList({ refetch });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        showOrientation
        inject_ui_table_actions
        grid={
          <GeneralCard
            isChecked={false}
            showCheck
            type={"faq"}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
        }}
        refetch={refetch}
        endpoint={endpoint["faqs"]}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<FAQForm />}
      />
    </>
  );
};

export default index;
